import Vue from "vue";
import VueRouter from "vue-router";
import "@/styles/app.scss";
/// IMPORTAR CONTAINER
import Lti from "@/containers/Lti.vue";
import BaseAdmin from "@/containers/BaseAdmin";
import Page401 from "@/views/pages/Page401";
import Page400 from "@/views/pages/Page400";
import Page403 from "@/views/pages/Page403";
import Page404 from "@/views/pages/Page404";
import Page500 from "@/views/pages/Page500";
// IMPORTAR COMPONENTES
import LoginAdmin from "@/views/LoginAdmin";
import LicencesAdmin from "@/components/Admin/LicencesAdmin";
import RevisionesLti from "@/components/Lti/Revisiones";
import i18n from "@/i18n";

const routes = [
  {
    path: "/",
    component: Lti,
    redirect: "/login",
    children: [
      {
        path: "reviews",
        name: "Revisiones",
        meta: { title: i18n.t("header.reviews") },
        component: RevisionesLti,
      },
    ],
  },
  {
    path: "/lti",
    component: Lti,
  },
  {
    path: "/login",
    name: "LoginAdmin",
    meta: { title: "PROEDUCA Revisiones" },
    component: LoginAdmin,
  },
  {
    path: "/admin",
    name: "BaseAdmin",
    component: BaseAdmin,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "licences",
        name: "LicencesAdmin",
        meta: { title: "Licencias LTI" },
        component: LicencesAdmin,
        //   component: HelloI18nVue,
      },
    ],
  },
  {
    path: "/pages",
    redirect: "/pages/404",
    name: "Pages",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "400",
        name: "Page400",
        component: Page400,
        props: (route) => ({ error: route.query.error }),
      },
      {
        path: "401",
        name: "Page401",
        component: Page401,
      },
      {
        path: "403",
        name: "Page403",
        component: Page403,
      },
      {
        path: "404",
        name: "Page404",
        component: Page404,
      },
      {
        path: "500",
        name: "Page500",
        component: Page500,
      },
    ],
  },
  {
    path: "*",
    name: "404",
    component: Page404,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
Vue.use(VueRouter);

/**
 * Se utiliza el título de router como título de las páginas
 */
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta?.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta?.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll("[data-vue-router-controlled]")).forEach(
    (el) => el.parentNode.removeChild(el)
  );

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map((tagDef) => {
      const tag = document.createElement("meta");

      Object.keys(tagDef).forEach((key) => {
        tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute("data-vue-router-controlled", "");

      return tag;
    })
    .forEach((tag) => document.head.appendChild(tag));

  next();
});

/**
 * Todo acceso a cualuqier ruta de vue, excepto a /login debe ser autenticado
 */
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!window.$cookies?.get("LTI_JWT")) {
      next({
        path: "/login",
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
